<template>
  <div class="dropdown" v-bind:class="{ 'is-active': isActive }">
    <div class="dropdown-trigger" v-on:click="toggleDropdown">
      <button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
        <span>{{ filterTitle }}</span>
        <span class="icon is-small">
          <i class="fas fa-angle-down"></i>
        </span>
      </button>
    </div>
    <div class="dropdown-menu" id="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <a href="#" class="dropdown-item"
          v-for="item in filterList"
          v-bind:key="item.id"
          v-on:click="filterClick(item.id)">
          {{ item.label }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    filterTitle: String,
    filterList: Array,
  },
  data() {
    return {
      sharedStore: this.$root.store,
      isActive: false,
    };
  },
  methods: {
    toggleDropdown() {
      if (this.isActive) {
        this.isActive = false;
      } else {
        this.isActive = true;
      }
    },
    filterClick(id) {
      this.sharedStore.setFilter(id);
      this.isActive = false;
      this.$emit('filter-change');
    },
  },
};
</script>

<style scoped lang="scss">

</style>
